(function ($) {

    // helpers
    let parseQuery = function (queryString) {
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    };

    var getCookie = function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    };

    var setCookie = function (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    };


    // site wide logic
    $(document).ready(function () {

        // partner setup
        let initSavings = function (code, discount, discountType, presetMessage) {
          
          	let discountStr = "";
            if( discountType == "flat" ){
    	        discountStr = "$" + discount;
	        } else if( discountType == "percent" ){
     	        discountStr = parseFloat(discount).toFixed(0) + "%";
            }

          
            if( !$('body').is('.no-discount, .template-customers-login,.template-customers-account,.template-customers-order') && typeof RF.freezeAnnouncement == "undefined" ){
                $('.announcement-bar').remove();
                $('header.site-header').before('<div class="announcement-bar"><p class="announcement-bar__message"><!-- We Ship Nationwide! --> <span class="partner-message">' + (presetMessage || ('Hi Savers! Enjoy your ' + discountStr  + ' discount site-wide! (Code ' + code + ')')) + '</span></p></div>');
            }
          
            if( $('body').is('.no-discount') ){
              return;
            }
          

            let getPrice = function (str) {
                let search = str.match(/([0-9]+\.?[0-9]{0,2})/);
                if (search == null) {
                    return null;
                } else {
                    return search[0];
                }
            };

            
          
            RF.discountedAmount = function (price) {
              if( discountType == "flat" ){
                return (price - discount).toFixed(2);
              } else if( discountType == "percent" ){
				return (price * ((100 - discount)/100)).toFixed(2);
              } else {
                return price;
              }
            };
          


            // collection / product grid
			let blocked = function(url){
              let blacklist = ["three-months-of-roses", "twelve-months-of-roses", "six-months-of-roses","monthly-flowers-rose-subscription","spring-special"];
              for( var i = 0; i < blacklist.length; i++){
                if( url.indexOf( blacklist[i] ) >= 0 ){
                  return true;
                }
              }
              return false;
            };
          
            $('.product-card .price--listing span.price-item--regular').each(function (e) {

                let link = $(this).parents('.product-card').find('a[href]');
                if( blocked( link.attr('href') ) ){
                    return;
                }

                let oldPrice = getPrice($(this).html());
                $(this).html('from <s>$' + oldPrice + '</s> <span class="new-price">$' + RF.discountedAmount(oldPrice) + ' <span class="savings-pct">' + discountStr  + ' off</span></span>');
            });

            // product page
            $('.quantity-container .quantity:not(.quantity-discounted)').not('.no-discount').each(function (e) {
                $(this).data('price', RF.discountedAmount($(this).data('price')/100)*100);
                $(this).addClass('quantity-discounted');

                let oldPriceLabel = $(this).find('label.price');
                oldPriceLabel.html("<s>" + oldPriceLabel.html() + "</s>");
                oldPriceLabel.addClass('price-orig');

                $(this).append('<label class="price">$' + RF.discountedAmount(getPrice(oldPriceLabel.html())) + '</label>');
            });
            $('.quantity-container .quantity-active').click(); // trigger page recalc

            // single-quantity product page
            $('.product-single .price__pricing-group span.price-item--regular').not('.no-discount').each(function(){
                let oldPrice = getPrice($(this).html());
                $(this).html('<s>$' + oldPrice + '</s> <span class="new-price">$' + RF.discountedAmount(oldPrice) + ' <span class="savings-pct">' + discountStr  + ' off</span></span>');
            });

            // sympathy product card
            $('#Collection.collection-sympathy .product-card__title span.price').each(function(){
                let oldPrice = getPrice($(this).html());
                
                let link = $(this).parents('.product-card').find('a[href]');
                if( blocked( link.attr('href') ) ){
                    return;
                }
              
              	if( $('.collection-valentines').length > 0 ){
                  $(this).html('<s>$' + oldPrice + '</s> <span class="new-price" style="display: initial">$' + RF.discountedAmount(oldPrice) + ' <span class="savings-pct" style="display: initial">' + discountStr  + ' off</span></span>');                  
                } else { 
	                $(this).html('<s>$' + oldPrice + '</s> <span class="new-price">$' + RF.discountedAmount(oldPrice) + ' <span class="savings-pct">' + discountStr  + ' off</span></span>');
                }
            });

            // cart
            let modifyCart = function (e) {
                // Lookup whether a non-discountable product is in cart
                let hasNonDiscountProduct = false;
                let hasDiscountProduct = false;

                let discountTarget = $('#shopify-section-cart-template form[method=post]');
                $('#shopify-section-cart-template table tr.cart__row').each(function () {
                    let variantId = $(this).data('cart-item-key').split(":")[0];
                    if( RF.isDiscountable( variantId ) ){
                        hasDiscountProduct = true;
                    } else {
                        hasNonDiscountProduct = true;
                    }
                });

                if( !hasDiscountProduct ){
                    discountTarget.find('input[name=discount]').remove();
                } else {
                  let cartTotal = 0;
                  
                  if( discountType == "flat" ){
                    
                    let discountableAmount = 0;
                    $('#shopify-section-cart-template table tr.cart__row').each(function () {
                        let qty = $(this).find('td.cart__quantity-td input.cart__qty-input').val();
                        let costEl = $(this).find('div[data-cart-item-price] dd[data-cart-item-regular-price]');
                        let itemCost = getPrice(costEl.html());

                        let variant = $(this).data('cart-item-url').match(/[0-9]+$/);
                        if (variant != null && variant.length > 0 && RF.isDiscountable( variant[0] ) ) {
                          discountableAmount += (qty * itemCost );
                        }
                        cartTotal += (qty * itemCost);
                    });
                    
                    let discounted = Math.min(discountableAmount, discount);
                    cartTotal = cartTotal -  discounted;     
                    $('.cart-discount').remove();
                    $('.cart__footer .cart-subtotal').before('<div class="cart-discount"><span class="cart-subtotal__title">Discount</span><span class="cart-discount__price">-$' + discounted.toFixed(2) + ' USD</span></div>');
                    
                    
                  } else if( discountType == "percent" ){


                    $('#shopify-section-cart-template table tr.cart__row').each(function () {


                        let qty = $(this).find('td.cart__quantity-td input.cart__qty-input').val();
                        let costEl = $(this).find('div[data-cart-item-price] dd[data-cart-item-regular-price]');
                        let itemCost = getPrice(costEl.html());

                        let variant = $(this).data('cart-item-url').match(/[0-9]+$/);
                        if (variant != null && variant.length > 0 && RF.discountable && RF.discountable[variant[0]]) {

                            let finalCostEl = $(this).find('td.cart__final-price span[data-cart-item-regular-price]');
                            let discountCost = RF.discountedAmount(itemCost)
                            costEl.html("<s>$" + itemCost + "</s> $" + discountCost);
                            finalCostEl.html("<s>$" + (itemCost * qty).toFixed(2) + "</s> $" + (qty * discountCost).toFixed(2));
                            cartTotal += (qty * discountCost);
                        } else {
                            cartTotal += (qty * itemCost);
                        }
                    });
                  }
                  
                  $('.cart__footer .cart-subtotal__price').html("$" + cartTotal.toFixed(2) + " USD");
                  discountTarget.append('<input type="hidden" name="discount" value="' + code + '"/>');

                }
            };
            modifyCart();
            $('#shopify-section-cart-template').on('cart-redrawn', modifyCart);
            // end cart

            // wedding page
            let weddingPriceEl = $('.page-wedding .wedding-price');
            if (weddingPriceEl.length > 0) {
                let weddingPrice = weddingPriceEl.html();
                weddingPriceEl.html("<s>" + weddingPrice + "</s> $" + RF.discountedAmount(getPrice(weddingPrice)));
            }
            // end wedding price

        };

        let fetchSavings = function (aid) {
            fetch("https://partner.rosefarmers.com/api/savings", {
                method: "POST",
                body: JSON.stringify({action: "getSavings", aid: aid}),
                headers: {"Content-Type": "application/json"}
            })
                .then(function (resp) {
                    return resp.json();
                })
                .then(function (data) {
                    if (data && data.success) {


                        if (window.location.pathname == "/products/rose-farmers-voucher") {
                            return;
                        }

                        $('.dyn-partner-name').html(data.partner);

                        fetch("/cart.json", {headers: {"Content-Type": "application/json"}})
                            .then(function (resp) {
                                return resp.json();
                            })
                            .then(function (data2) {
                                let hasGc = false;
                                if (data2 && data2.items) {
                                    for (var i = 0; i < data2.items.length; i++) {
                                        if (data2.items[i].sku.substr(0, 3) == "GC-") {
                                            hasGc = true;
                                            break;
                                        }
                                    }
                                }
                                if (!hasGc && typeof RF.freezeDiscounts == "undefined" ) {
                                    //initSavings(data.savingsCode, data.savingsPercent, data.message || null);
                                    initSavings(data.savingsCode, data.savingsAmount, data.savingsType, data.message || null);

                                }
                            });

                    } // end if data && success

                });
        };

        let qs = parseQuery(window.location.search);

        let aid = getCookie("aid");
        if( RF.aid ){
            fetchSavings( RF.aid );
        } else if (qs.aid) {
            $('body').append('<img src="https://partner.rosefarmers.com/logo.gif?aid=' + qs.aid + (qs.subid ? '&sid=' + qs.subid : (qs.subid1 ? '&sid=' + qs.subid1 : '') ) + (qs.subid2 ? '&sid2=' + qs.subid2 : '') + (qs.subid3 ? '&sid3=' + qs.subid3 : '') + '"/>');
            fetchSavings(qs.aid);
            aid = qs.aid;
            RF.aid = aid;
        } else if (aid){
            fetchSavings(aid);
            RF.aid = aid;
        }
        RF.isGroupon = (aid == "ZE6");

        if( qs.fbCode ){
            var el = document.createElement('script');
            el.src = "https://rosefarmers.com/discount/" + qs.fbCode ;
            document.body.appendChild(el)
        }

        window.SP = window.SP || {};
        SP.promptConfig = SP.promptConfig || {};
        SP.promptConfig.affiliateId = aid || null;


        var promptedCookie = getCookie(SP.promptConfig.promptedCookie);
        if( aid ){
            if( aid == "6NJ" ) {
                SP.promptConfig.campaign = "rf-35off-modal";
                SP.promptConfig.prompt1 = "Get $30 Off!<span>*</span>";
                SP.promptConfig.codeLabel = "$30 Off Code";
                SP.promptConfig.launchSec = null;
                SP.promptConfig.promptedCookie = "prompted35";
                SP.promptConfig.thankYouLabel = "<br/>Check your email for your $30 coupon.<br/>Enjoy our Finest Roses!";
                SP.promptConfig.sideImage = "https://cdn.shopify.com/s/files/1/0338/1732/9799/t/5/assets/gc-30.png?v=1600199510";
                promptedCookie = getCookie(SP.promptConfig.promptedCookie);
            } else if( aid == "H3B" || aid == "42W" ){
                     // do nothing, allow
            }  else {
                promptedCookie = "skip";
            }
        }
        if( getCookie("fbCode") != "" ){
            SP.stopPrompt = true;
        }
        if( SP && SP.prompt && SP.prompt.display ) {
            if( promptedCookie == "" ){
              SP.prompt.display();
              setCookie(SP.promptConfig.promptedCookie, true, 365);
            } else if( window.location.search && window.location.search.indexOf("newsletter") > -1  ){
              SP.promptConfig.launchSec = 0;
              SP.prompt.display();
            }
        }
        // end partner setup


      let strikeCookie = "strikeJune2022";
      if( false && getCookie( strikeCookie ) == "" ){
        $('#strikeModal').css('display','flex');
        setCookie(strikeCookie,true,365);
      }      
      

      if(  false  ){
        let popupCookieName = "lilies2026Sale";
        let isPartner = false;
        let partnerAid = getCookie("aid");
        if( partnerAid == "YJJ" || partnerAid == "42W" || partnerAid == "7QP" || partnerAid == "P33" ){
          isPartner = true;
        }

        if(!isPartner && getCookie(popupCookieName) == ""  ){
		  SP.stopPrompt = true;          
      	  $('#promoModal').css('display', 'flex');
          setCookie(popupCookieName, true, 365);
        }
        if( true || !isPartner ){
        	RF.freezeAnnouncement = true;
        	$('.announcement-bar').remove();
            $('header.site-header').before('<div class="announcement-bar" style="margin-top: -2px"><p class="announcement-bar__message"><a href="https://rosefarmers.com/products/mixed-lilies"><b>Flash Sale</b>:  50% Off Lilies <span style="text-decoration: underline"> Shop Now &rarr;</span> </a></p></div>');
        }
      }
      
      let partnerContact = $('a[href="#partnerModal"]');
      if( partnerContact.length > 0 ){
        partnerContact.attr("data-modalselector", "#partnerModal");
        partnerContact.addClass("rf-show-modal");
      }
      if( (window.location.search || "").indexOf("contact_posted=true") !== -1 ){
        alert("Thank you for contacting Rose Farmers!\n\nYour message has been sent, and a member of the Rose Farmers Team will be reaching out to you shortly!");
      }
      
        // contact us popups
        $('.rf-show-modal').click(function (e) {
            e.preventDefault();
            let modal = $($(this).data('modalselector'));
            modal.css('display', 'flex');
            $('body').append(modal.detach());
            return false;
        });

        $('body').on('click', '.rf-modal .close, .rf-modal .btn-close, .mr-modal .close, .mr-modal .btn-close', function (e) {
            e.preventDefault();
            $(this).parents('.rf-modal,.mr-modal').hide();
            return false;
        });
        // end contact us popups

    });


    window.RF = window.RF || {};
    RF.config = RF.config || {};
    RF.config.noonDeliveryVariantId = RF.config.noonDeliveryVariantId || "35371234427041";
    RF.config.noonDeliveryPrice = RF.config.noonDeliveryPrice || "4.99";

//    RF.holidays = ['2025-09-01','2025-09-02'];
  
    RF.vendorHolidays = {
      A: [],
      B: ['2026-04-07','2026-04-08'],
      C: ['2026-04-07','2026-04-08'],
      D: []
    };
  
    RF.getCurrentShippingDay = function ( vendor ) {
      // Calculate earliest available shipping date:
      let ships = moment().tz("America/New_York");
      if( RF.shippingDayOffset ){
          ships.add(RF.shippingDayOffset, 'days');
      }

      switch( vendor ){
          case "B":
          case "C":
            switch( ships.format("Y-MM-DD") ){
              default:
                let pastCutoff = (ships.hour() >= 8 || (ships.hour() == 7 && ships.minute() >= 30) );
  
                if (ships.day() == 0 || ships.day() == 4) { // If Sunday, submits Monday, Thursday submits Friday
                    ships.add(1, 'days')
                } else if( ships.day() == 6 ){ // If Saturday, submits Monday
                    ships.add(2, 'days');
                } else if( ships.day() == 5 && pastCutoff ){
                  ships.add(3, 'days');
                } else if ( pastCutoff ){
                  ships.add(1, 'days');
                }
            }
          break;

          case "D":
              let pastCutoff = (ships.hour() >= 8 || (ships.hour() == 7 && ships.minute() >= 30) );
              if( pastCutoff ){
                  ships.add(1, 'days');
              }
                //Thurs/Fri/Sat leave alone
              if (ships.day() >= 0  && ships.day() <= 3 ) { // If Sunday through Wed, ships next Thurs
                  ships.add(5 - ships.day(), 'days');
              }
          break;

          case "E":
            ships.add(6, 'days');
          
              if(ships.hour() >= 14 || (ships.hour() == 13 && ships.minute() >= 30) ){
                  ships.add(1, 'days');
              }

              if (ships.day() == 0 ){ // Sun ships Mon
                  ships.add(1, 'days');
              }
              break;

          case "A":
          default:

          switch( ships.format("Y-MM-DD") ){
            default:
              if (ships.day() == 0) { // If Sunday, ships Monday
                  ships.day(1);
              } else if ( 
                  ( (ships.day() >= 1 && ships.day() <= 5) && (ships.hour() >= 12 || (ships.hour() == 11 && ships.minute() >= 40) ) )
                  // || ( (ships.day() == 1 ) && (ships.hour() >= 13 || (ships.hour() == 12 && ships.minute() >= 40) ) )
              ) {// Tue/Wed/Thur/Fri
                  ships.add(1, 'days');          
              } else if (ships.day() == 6 && (ships.hour() >= 10 || (ships.hour() >= 9 && ships.minute() >= 40) ) ) { // Saturday
                  ships.day(8); // next monday
              }
          }

      }

      return ships;
    };

    RF.fetchNoInventoryDates = function( color, cb ){
      let managedColors = {"DATESS": true, "DAKEI": true, "ROMANT": true };
        if( managedColors[ color ] ){
            fetch("https://orders.rosefarmers.com/api/color-avail-dates?color=" + color,{
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            }).then( function(resp){ return resp.json(); })
                .then( function(data){ if( data.success ){
                    RF.noInventoryDates = {};
                    for( var i = 0; i < data.blockedDates.length; i++){
                        RF.noInventoryDates[ data.blockedDates[i] ] = true;
                        cb();
                    }
                } })
                .catch( function(err){ console.log(err); });
        }
        cb();
    }

    RF.closestDeliveryDate = function( momentDate, customTester, vendor ){
        // Avoid holidays/Sundays

        let updatedDate = false;
        do {
            updatedDate = false;

            // Check for date being a global or vendor holiday
            let holidaySets = [RF.holidays, RF.vendorHolidays[ RF.cleanVendor(vendor) ]];                  
            for( var j = 0; j < holidaySets.length; j++){
               if( Array.isArray( holidaySets[j] ) ){
                 for (var i = 0; i < holidaySets[j].length; i++) {
                   if (momentDate.format("Y-MM-DD") == holidaySets[j][i]) {
                    momentDate.add(1, 'days');
                    updatedDate = true;
                   }
                 }  
               }
             }

          
          
            if( momentDate.day() == 0 ){
                momentDate.add(1,'days');
                updatedDate = true;
            }

            if( RF.noInventoryDates && RF.noInventoryDates[ momentDate.format("Y-MM-DD") ] ){
                momentDate.add(1,'days');
                updatedDate = true;
            }

            if( typeof customTester != "undefined" && customTester != null && customTester( momentDate ) == false ){
                momentDate.add(1,'days');
                updatedDate = true;
            }

        } while( updatedDate );

        return momentDate;
    };

    RF.cleanVendor = function( vendor ){
        if( !vendor || vendor == "Rose Farmers"){
            vendor = "A";
        }
        return vendor;
    }
    RF.getEarliestArrivalDay = function (shipSpeed, vendor) {

        if( typeof vendor == "undefined" ){
            vendor = "A";
        }
      if( typeof RF.turnaround != "undefined"){
        shipSpeed = RF.turnaround;
      }

      
        let earliestArrival = RF.getCurrentShippingDay(vendor);
if( !!RF.lastminuteProduct ){
  earliestArrival.subtract(1,'days');
}

        switch (shipSpeed) {
          case 0: break;
          case 2: earliestArrival.add(2, 'days'); break;
            
            
            case 3:
                switch( vendor ) {

                    case "A":

                        switch (earliestArrival.day()) {
                            case 1: // mon => thur
                            case 2: // tue => fri
                                earliestArrival.add(3, 'days');
                                break;

                            case 3: // wed => Mon
                                earliestArrival.add(5, 'days');
                                break;
                            
                            case 6: // sat => Wed
                                earliestArrival.add(4, 'days');
                                break;

                            case 4: // thur => monday
                            case 5: // Fri => tuesday
                                earliestArrival.add(4, 'days');
                                break;

                            case 0: // sunday (ships monday) => thur
                                earliestArrival.add(4, 'days');
                                break;

                        }
                        break;
                    case "B":
                    case "C":
                        switch (earliestArrival.day()) {
                            case 1: // mon => thur
                            case 2: // tue => Fri
                                earliestArrival.add(3, 'days');  
                                break;

                            
                          case 5: // fri=> Tue
                            	earliestArrival.add(4, 'days');
                                break;
                            
                            case 3: // wed => Monday
                            case 4: // thur => Tue                            
                            	earliestArrival.add(5, 'days');
                                break;

                        }
                        break;

                    case "D":
                        switch (earliestArrival.day()) {
                            case 4: // Thur => Wed
                                earliestArrival.add(6, 'days');
                                break;
                            case 5: // Fri=> Wed
                            case 6: // Sat=> Thur
                                earliestArrival.add(5, 'days');
                                break;

                        }
                        break;

                    case "E":
                        earliestArrival.add(5, 'days');
                        break;
                }
                break;

            case 1:
            default:

                switch (earliestArrival.day()) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        earliestArrival.add(1, 'days');
                        break; // mon - thur, could be next day
                    case 5:
                        earliestArrival.add(3, 'days');
                        break; // Friday, arrives Monday or later
                }
                break;
        }

        return RF.closestDeliveryDate(earliestArrival, null, vendor);

    };

    RF.initNoteField = function (noteChangeCallback) {
        $('input[name=note]').off('change').change(function (e) {
            if ($(this).prop('checked') ) {
                $('.note-container').show();
            } else {
                $('.note-container').hide();
            }
        });

        let recipEmail = $('input[name=recipientEmail]');
        let cleanEmail = function( val ){
            return val.replace(/^\s+/g,'').replace(/\s+$/g, '');
        };
        let isValidEmail = function( val ){
            let valid = val.length == 0 || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( val );
            return valid;
        };

        recipEmail.change(function(){
            // trim val
            let container = $(this).parents('.delivery-alert-container');
            let val = cleanEmail( $(this).val() );
            $(this).val( val );

            if( isValidEmail( val ) ){
                container.removeClass('invalid-email');
            } else {
                container.addClass('invalid-email');
            }
            noteChangeCallback();
        }).change();

        recipEmail.keyup(function(){
           if( isValidEmail( $(this).val() )  ){
               $(this).parents('.delivery-alert-container').removeClass('invalid-email');
           }
        });

        $('input[name=note][value=yes]').prop('checked', true).change();
        $('input[name=notetype][value=digital]').prop('checked', true).change();
        $('#note').off('change').change(noteChangeCallback);
        $('#noteFrom').off('change').change(noteChangeCallback);

        // Offer a reminder email
        let reminderCheckbox = $('.reminder-container input[name=annualreminder]');
        reminderCheckbox.off('change').change(function () {
            if ($(this).prop('checked')) {
                $('.occasion-container').show();
            } else {
                $('.occasion-container').hide();
            }
            noteChangeCallback();
        });
        reminderCheckbox.prop('checked',false).change();
        $('.reminder-container [name=reminder_type]').off('change').change(function(){
            noteChangeCallback();
        });
    };

    RF.initAddons = function (config){
      
        if( $('.addons-container').not('.included').length == 0 ){
          return {getSelected: function(){ return []}, setSkuSlug: function(){}, setSelectedQuantity: function(){}};
        }

        $('.enhancement.enhancement-active').removeClass('enhancement-active');

        $('.enhancements-container:not(.included) .enhancement div.img').off('click').click(function (e) {
            let enhEl = $(this).parents('.enhancement');
            let containerEl = $(this).parents('.enhancements-container');
          	if( containerEl.is('.single-select') ){
              	let allEnhancements =  containerEl.find('.enhancement');
                for( let i = 0; i < allEnhancements.length; i++){
                  if( allEnhancements[i] != enhEl[0] ){
                    $(allEnhancements[i]).removeClass('enhancement-active');
                  }
                }
          	}
          
            if( config.vendor == "B" || config.vendor == "C" ){
                let active = containerEl.find('.enhancement-active');
              	if( active.length >= 2 ){
                  alert("You may only select 2 Addons per Bouquet.  Please remove an addon before adding another.");
                  return false;
              	}
            }
          
            if( !enhEl.is('.included') ){
              enhEl.toggleClass('enhancement-active');
              config.onSelect();
            }
        });

        let retObj = {
            getSelected: function(){
                let addons = {};
                $('.enhancement.enhancement-active').not('.included').each(function(){
                  	if( $(this).data('sku') != "none" ){
                    	addons[ $(this).data('variantid') ] = {qty: 1};
                  	}
                });
                return addons;
            },
            manageVaseDisplay: function( stems ){
				let vase = $('.vase-container');
                vase.show();
	          	if( stems > 36 ){
    	        	vase.find('.enhancement-active').removeClass('enhancement-active');
 			   		vase.hide();
          		} else if( vase.find('.enhancement:visible').length == 0 ) {
	          	    vase.hide();
                } else {
            		vase.show();
	            }                
            },
          
            setSkuSlug: function( slug ){
                if( RF.addons ) {
                    let addonsShown = 0;

                    for (let i = 0; i < RF.addons.length; i++) {
                        let addon = RF.addons[i];
                        let addonEl = $('.enhancements-container').not('.included').find('.enhancement[data-productid="' + addon.id + '"]');
                        let containerEl = addonEl.parents('.enhancements-container');
                        let isVase = addon.tags.includes("vase");

                      	if( !isVase && !addon.tags.includes('addon-dynamic') ){
                        	continue;
                      	}

                      	if( typeof RF.blockedAddons != "undefined" && RF.blockedAddons[ addon.id ]){
                      	    addonEl.hide();
                      	    continue;
                        }
                        
                        let selectedVar = null;
                        for( let j = 0; j < addon.variants.length; j++){
                            let parts = addon.variants[j].sku.split("-");
                            if( isVase ){
                                if( !!RF.vaseSkuSlug ){
                                    if( parts.length > 2 && parts[2] == RF.vaseSkuSlug ){
                                        selectedVar = addon.variants[j];
                                    }
                                } else {
                                    selectedVar = addon.variants[0];
                                    break;
                                }

                            } else {
                                if( config.vendor == "A" ){
                                    if (parts.length >= 2 && parts[1] == slug) {
                                        selectedVar = addon.variants[j];
                                    }
                                } else {
                                    selectedVar = addon.variants[j];
                                    break;
                                }
                            }
                        }

                        addonEl.show();
                        let priceEl = addonEl.find('label.price span');
                        if( addonEl.is('.included') ){
                            if( !isVase ) {
                                addonEl.data('variantid', "");
                            }
                            priceEl.html("Included");
                            addonsShown++;
                        } else if( selectedVar == null || addonEl.is('.hidden') ) {
                            addonEl.hide();
                        } else {
                            addonEl.data('variantid', selectedVar.id);
                            if( selectedVar.price == 0 ){
                                priceEl.html(RF.addonWord || "Free");
                            } else {
                                priceEl.html( "$" + (selectedVar.price/100).toFixed(2) );
                            }

                            let compareAtEl = addonEl.find('.compare-price'); 
                            if( selectedVar.compare_at_price && selectedVar.compare_at_price > selectedVar.price){
                                compareAtEl.html( "$" + (selectedVar.compare_at_price/100).toFixed(2) );
                            } else {
                                compareAtEl.html('');
                            }

                            addonsShown++;
                        }

                    }


                    $('.enhancements-container').not('.included').each(function(){
                       if( $(this).find('.enhancement:visible').length == 0 ){
                           if( !$(this).is('.included') ){
                               $(this).hide();
                           }
                       } else {
                           $(this).show();
                       }
                    });
                  

                     if( Array.isArray(RF.addonsCompleteListeners) ){
                       for( let i = 0; i < RF.addonsCompleteListeners; i++){
                         RF.addonsCompleteListeners[i]();
                       }
                     }
                      

                }
            }
        };

        retObj.setSelectedQuantity = function( qty ){
          	// Hide/show vases based on actual passed qty
          	retObj.manageVaseDisplay( qty );
  
            // Adjust qty to match an addon tier 12/24/48
            if( qty < 12  ){
                qty = 12;
            }
            if( qty == 16 ){
              	qty = 24;
            }
            if( qty == 36 ){
                qty = 48;
            }
            retObj.setSkuSlug("QTY" + qty );
          
        };

      
        // Wire up to detect qty changes on std product page to hide/show vases container
      	$('.quantity-container').on('click', '.quantity', function(){
          let qty = $(this).data("qty");
          let vase = $('.vase-container');
          if( qty ){
              retObj.manageVaseDisplay( qty );          
          } else {
              vase.show();
          }
          return true;
      	});
      
        return retObj;
    };

    RF.alert = function(body,headline){
        let el = $('#rfAlertModal');

        el.find('.btn-close,.close').off('click').click(function(){
            el.css('display','none');
        });

        el.find('.body').html( body );
        el.find('.headline').html( headline );

        el.css('display', 'flex');
    };

    RF.isSubmitPossible = function(){
        let ret = {possible: true, message: null};
        let noteFrom = $('#noteFrom').val();
        let note = $('#note').val();

        if( $('#noteToggle').prop('checked') && ((note ||"") + (noteFrom || "")).replace(/^\s+/g,'').replace(/\s+$/g, '').length == 0 ) {
            ret.possible = false;
            RF.alert("Type your note in the text box and proceed to the cart!","Did you forget to include a message?");
        }

        return ret;
    };

    RF.initProductPage = function (config) {
        const deliveryDateInput = document.getElementById("deliveryDate");
        let upsellModal = null;
       	let lines = [];
      let properties = {};
      config.vendor = RF.cleanVendor( config.vendor );
      config.redirect = config.redirect || function(){ window.location.href = "/cart"; };
      
        let addons = RF.initAddons({onSelect: function(){}, vendor: config.vendor });
        addons.setSelectedQuantity( $('.quantity-active').data('qty') );

      // remove after MDay 2025
      if( config.vendor == "A"){
      //config.defaultDate =  new Date( 2025, 5 - 1, 8);
      }


        let initDatePicker = function( ){
            // handle fetching existing data / re-filling after reinit
            RF.initDeliveryDatePicker({
                vendor: $('.quantity-active').data('vendor') || config.vendor,
                deliveryDateInput: deliveryDateInput,
                shipSpeed: 3,
                datePickCallback: function(date){},
                defaultDate: config.defaultDate || null,
                overwriteValue: true              
            });
        };

        $('.quantity-row .quantity').click(function (e) {
            $('.quantity-row .quantity').removeClass('quantity-active');
            $(this).addClass('quantity-active');
            addons.setSelectedQuantity( $(this).data("qty") );
            initDatePicker();
            return true;
        });


        RF.fetchNoInventoryDates(config.color, function(){
          initDatePicker( );
        });


        
      RF.initNoteField(function(){});
      
      let submitForm = function(){

          // Allow external modification of lines before adding
          if( !!config.onBeforeSubmit ){
              lines = config.onBeforeSubmit( lines );
          }

          let addItems = function(){
              RF.addLinesToCart( lines ).then( config.redirect );
          };

          if( config.onBeforeAddToCart ){
              config.onBeforeAddToCart( addItems );
          } else {
              addItems();
          }

      };
      
      if( !!config.upsellModal ){
        config.upsellModalOpts = config.upsellModalOpts || {};
          
        config.upsellModalOpts.onAccept = function(variant){
          lines.push( {id: variant, quantity: 1} );
          submitForm();
        };
        config.upsellModalOpts.onDecline = function(){
          submitForm();
        };
          
        config.upsellModalOpts.watchAddToCartButtons = false;
          
        upsellModal = RF.initUpsellModal( config.upsellModalOpts );
      }


      let weatherModal = RF.initWeatherModal();

      $('.product-form__item button[name=add]').click(function(){

          let executeSubmitLogic = function(){
              // Gather items/properties from page

              let common = RF.getCommonProperties( addons );
              lines = common.lines;
              properties = common.properties;


              let selectedQty = $('.quantity-active');
              if( selectedQty.length > 0 ) {
                  let varId = selectedQty.data(moment($(deliveryDateInput).attr('data-date')).day() == 6 ? 'varsat' : 'var3day');
                  if (varId) {
                      lines.push( {id: varId, quantity: 1, properties: properties} );
                  }
              }

              if (upsellModal == null ) {
                  submitForm();
              } else {
                  // hide weather modal before showing upsell modal
                  $('#weatherDelayModal').hide();

                  let modalSkipped = upsellModal.triggerStandard();
                  if (modalSkipped) {
                      submitForm();
                  }
              }
          };



          if( RF.isSubmitPossible().possible ) {
              weatherModal.triggerIfNeeded(
                  $(deliveryDateInput).attr('data-date'),
                  executeSubmitLogic
              );
          }
        
      	return false;
      });

      return {addons: addons};
      
    };

    RF.initWeatherModal = function(){
        let modal = $('#weatherDelayModal');

        let ret = {};


        ret.trigger = function(config){
            modal.find('.btn-alt').off('click').click(function(){
                $(this).parents('.rf-modal').hide();
            });

            modal.find('.btn-continue').off('click').click(function(){

                let handleUid = function(uid){
                    RF.agreements = RF.agreements || [];
                    RF.agreements.push( uid );
                    $(this).parents('.rf-modal').hide();
                    config.onAccept();
                };

                fetch("https://orders.rosefarmers.com/api/agree-terms?url=" + encodeURIComponent(window.location.href),{
                    headers: {"Content-Type": "application/json"}
                    })
                    .then(function(resp){ return resp.json(); })
                    .then(function(data){
                        handleUid(data.uid);
                    }).catch(function(data){
                        handleUid('none');
                    });
            });

            modal.css('display','flex');
        };


        ret.triggerIfNeeded = function( deliveryDate, callback ){
          let weatherDeliveryDates = ["2026-05-07","2026-05-08"];

            if( weatherDeliveryDates.indexOf( moment(deliveryDate).format("Y-MM-DD") ) >= 0 && !RF.agreements ){
                ret.trigger({"onAccept": function(){
                    callback();
                }});
            } else {
                callback();
            }
        };

        return ret;
    };

    RF.initSubscription = function (config) {
        let addons = RF.initAddons({onSelect: function(){}});
        addons.setSelectedQuantity( $('.quantity-active').data('qty') );

        $('.quantity').click(function (e) {
            $('.quantity.quantity-active').removeClass('quantity-active');
            $(this).addClass('quantity-active');
            addons.setSelectedQuantity( $(this).data('qty') );
        });

      $('.quantity-active').click();
      
      RF.initDeliveryDatePicker({
          deliveryDateInput: $('#deliveryDate')[0],
          shipSpeed: 3,
          datePickCallback: function(){},
          disableSaturday: true
      });
      $('.noondelivery-container').remove();
      
                
      $('form[action="/cart/add"]').submit(function(e){
          e.preventDefault();

          let common = RF.getCommonProperties( addons );
          let lines = common.lines;
          let properties = common.properties;

          properties.Frequency = $('.bsub-widget__plan-label input[type=radio]:checked').parents('.bsub-widget__plan-label').find('.bsub-widget__text').html()

          lines.push({
              id: $('.quantity-active').data('variantid'),
              quantity: 1,
              selling_plan: $('.bsub-widget__plans-container input[type=radio]:checked').attr('value'),
              properties: properties
          });

          RF.addLinesToCart(lines).then( function(){ window.location.href = "/cart"; } );

          return false;
      });

    };

    RF.initUpsellModal = function (config) {

        config = config || {};

        if( !RF.upsells ) {
            fetch('/collections/' + (config.collectionHandle || "upsells") + '/products.json')
                .then(function (resp) {
                    return resp.json();
                })
                .then(function (data) {
                    window.RF = window.RF || {};
                    RF.upsells = data.products;
                });
        }


        $('body').append($('.upsell-modal').detach());
        let modal = $('.upsell-modal');
        let productForm = $('form.product-form, form.builder-fields'); // product or one-page form tags

        let showModal = function (qtys, retailPrices) {

            // legacy usage was to pass single vars, place those into arrays
            if( typeof qtys == "number"){
                qtys = [qtys]
            }
            if( typeof retailPrices == "number"){
                retailPrices = [retailPrices];
            }

            let tiles = modal.find('.products-container');

            let priceMap = {};

            // Populate product tiles and priceMap
            for (var i = 0; i < RF.upsells.length; i++) {
                for (var j = 0; j < RF.upsells[i].variants.length; j++) {
                    let variant = RF.upsells[i].variants[j];
                    let parts = variant.sku.split("-");
                    for( var k = 0; k < qtys.length; k++) {


                        if (parts.length >= 3 && parts[1] == qtys[k] && parts[2] == (config.upsellSkuSuffix || "UPSELL") ) {
                            if( k == 0 ) {
                                tiles.append('<div class="product" data-title="' + RF.upsells[i].title.replace(/\s?\([^\)]+\)/, '') + '" data-color="' + parts[0] + '" data-price="' + variant.price + '"><img class="product-image" src="' + RF.upsells[i].images[0].src + '"></div>')
                            }

                            priceMap[ qtys[k] ] = parseFloat(variant.price);
                            if (parseFloat(variant.price) == parseInt(variant.price)) { // If is whole dollar, lop off decimal places
                                priceMap[ qtys[k] ] = priceMap[ qtys[k] ].toFixed(0);
                            }

                        }
                    }
                }
            }

            // Render upsell options
            let optionsContainer = $('.upsell-options');
            optionsContainer.find('.upsell-option').remove();
            for( var i= 0; i < qtys.length; i++ ){
                let price = priceMap[ qtys[i] ];
                optionsContainer.append('<label class="upsell-option" data-qty="' + qtys[i] + '"><input type="radio" name="upsell_option" value="' + qtys[i] + '"> Add ' + qtys[i] + ' More Roses for <s>' + retailPrices[i] + '</s> <b>' + price + '</b>! <span style="font-weight: bold;text-align: center;">SALE</span></label>');
            }
            $(modal).find('.upsell-option').click(function(e){
                $(modal).find('.upsell-option').removeClass('active');
                modal.find('.btn-add').html("Yes, add " + $(this).data('qty') + " more Roses!");
                $(this).addClass('active');
            });
            $(modal).find('.upsell-option').first().click();
            if( qtys.length > 1 ){
                optionsContainer.show();
            } else {
                optionsContainer.hide();
            }



            modal.find('.products-container .product').first().click();
            let headline = modal.find('h2');
            headline.removeClass('multi-option');
            if( !headline.is('.no-dyn-headline') ){
              if( typeof config.headline != "undefined"){
                   headline.html( config.headline );
              } else if ( qtys.length > 1 ) {
                  headline.addClass('multi-option').html("Want to Make Your Bouquet Extra Special?");
              } else {
                  headline.html('Add ' + qtys[0] + ' More Roses for <s>$' + retailPrices[0] +'</s> <span>$' + priceMap[ qtys[0] ] + '!</span> <br/><span style="font-weight: normal;display: block;text-align: center;">SALE</span>');
              }
            }

            modal.find('.btn-decline').html("No Thanks");
            modal.show();
            modal.find('.rf-modal, .mr-modal').show();
        };

        $(modal).off('click').on('click', '.product', function () {
            $(modal).find('.products-container .product').removeClass('active');
            $(this).addClass('active');
            modal.find('.product-label').html("<b>Type: </b>" + $(this).data('title'));
        });

        $(modal).find('.btn-decline').off('click').click(function () {
            if (config.onDecline) {
                config.onDecline();
            } else {
                productForm[0].submit();
            }
        });
        $(modal).find('.btn-add').off('click').click(function () {

            // Lookup variant ID for color/qty
            let selectedEl = $(modal).find('.product.active');
            let selectedVariant = selectedEl.data('variantid');

            if( !selectedVariant ){
              let selectedSku = selectedEl.data('color') + "-" + $('.upsell-option.active').data('qty') + "-" + (config.upsellSkuSuffix || "UPSELL");
              for (var i = 0; i < RF.upsells.length; i++) {
                  for (var j = 0; j < RF.upsells[i].variants.length; j++) {
  
  
                      if( RF.upsells[i].variants[j].sku == selectedSku ){
                          selectedVariant = RF.upsells[i].variants[j].id;
                      }
                  }
              }
            }

            if (config.onAccept) {
                config.onAccept(selectedVariant);
            } else {
                productForm.append('<input type="hidden" name="id[]" value="' + selectedVariant + '"/>');
                productForm[0].submit();
            }
        })




      
      let triggerStandard = function () {
        let quantity = $('.quantity-active');

        let origPricer = config.originalPricer || function (num ){
          switch( num ){
            case 12: return 40;
            case 24: return 60;
            case 48: return 118;
          }
        };

        if (quantity.is('.quantity-12, .quantity-12-custom, .quantity-8, .quantity-16')) {
          showModal( config.upsellQtys || [12,24], [origPricer(12),origPricer(24)]);
          return false;
        } else if (quantity.is('.quantity-24,.quantity-alwaysupsell')) {
          showModal( config.upsellQtys || [12], [origPricer(12)]);
          return false;
        }
        return true;
        };

      
      let submitButtons = $('button[type=submit][name=add], button[type=submit][name=submit_btn], form.builder-fields button[type=submit][name=submit_btn], form.builder-fields input[type=submit][name=submit_btn]');      
      if( typeof config.watchAddToCartButtons == "undefined" || config.watchAddToCartButtons ){
        // selector for product page "Add to Cart" button or promo one-page AtC button
      	submitButtons.off('click');
        submitButtons.click( triggerStandard );
      };

        // return external function for triggering
      return {trigger: showModal, triggerStandard: triggerStandard,  deinit: function(){ submitButtons.off('click'); }};
    };

    RF.enforceUpsells = function () {

        let lockdownAddonRow = function (rowEl) {
            $(rowEl).find('input.cart__qty-input').addClass('locked').prop('readonly', true);
        };


        // IF cart detected without base product, remove upsell products:
        $('#shopify-section-cart-template').on('cart-redrawn', function (e) {

            // Lock down all addon products
            $('tr.cart__row').each(function (i, el) {
                // Lock down items in Upsell collection
                let variant = $(el).data('cart-item-url').match(/[0-9]+$/);
                if (RF.upsellIds[variant]) {
                    lockdownAddonRow(el);
                }
            });


            // Detect upsell/addon collection product, require be matched with a standard collection product.  Remove if not.
            let cartState = e.detail;
            let hasStdProduct = false;
            let countQty4 = 0;
            let isQty4 = function( cartItem ){  return cartItem.sku.match(/^[A-Z]+\-4\-/); }
            let countStems = 0;
            let countDACustom12 = 0;
            let hasDAProduct = false;

            for (var i = 0; i < cartState.items.length; i++) {
                let variantId = cartState.items[i].variant_id;
                let qtyParts = cartState.items[i].sku.split("-");
                if( !!parseInt(qtyParts[1]) ) {
                    countStems += cartState.items[i].quantity * parseInt(qtyParts[1]);
                }

                if( isQty4( cartState.items[i] ) ){
                    countQty4 += cartState.items[i].quantity;
                }

                if( cartState.items[i].sku.indexOf("-12-CUSTOM") > -1 ){
                    countDACustom12++;
                }

                if (RF.stdProducts[variantId] || RF.promoProducts[variantId]) {
                    hasStdProduct = true;
                }

                // Wedding/Sympathy/Promo36 base bundle product is Standard
                if( cartState.items[i].sku.indexOf("-24-BUNDLE") > -1 || cartState.items[i].sku.indexOf("-36PROMO") > -1){
                    hasStdProduct = true;
                }

                // Bundle products are Standard
                if( cartState.items[i].sku.substr(0,5) == "BUND-"){
                    hasStdProduct = true;
                }
              
                if (RF.upsellIds[variantId ] || RF.addonIds[variantId] ) {
                    lockdownAddonRow($('tr.cart__row')[i]);
                }
                if( RF.daIds[ variantId ] ){
                    hasDAProduct = true;
                }


            }

            // Require a standard product, unless bought 3x sets of 4, then exempt from that rule ( to allow upsell on 3x 4)
            if (!hasStdProduct && countQty4 == 0 && countDACustom12 == 0) {
                for (var i = 0; i < cartState.items.length; i++) {
                    let variant = cartState.items[i].variant_id;
                    let remove = false;

                    if (RF.upsellIds[variant] && !isQty4(cartState.items[i]) ) { // Don't remove Qty 4, will handle below
                        remove = true;
                    }

                    if( RF.addonIds[variant] ){
                        remove = true;
                    }

                    if( remove ) {
                        $($('tr.cart__row')[i]).find('p.cart__remove a').click();
                    }
                }
            }
            // end Detect Promo / Addon / Standard Product
  
          

            let limitLineQty = function( lineTester ){
              let vaseLineCount = 0;
              for (var i = 0; i < cartState.items.length; i++) {
                if( lineTester( cartState.items[i] ) ){
                  vaseLineCount++;
                  if( vaseLineCount > 1){                
                      $($('tr.cart__row')[i]).find('p.cart__remove a').click();
                  } else {
                      lockdownAddonRow( $('tr.cart__row')[i] );
                  }                
                }
              }
            };
            let lockdownRegex = function( regex ){
                for (var i = 0; i < cartState.items.length; i++) {
                    if( !!cartState.items[i].sku.match(regex)  ){
                        lockdownAddonRow( $('tr.cart__row')[i] );
                    }
                }
            };
            // lock vase/bear/basket line items.  Remove extra if  more than 1 exist
            limitLineQty( function(item){ return !!item.sku.match(/^(VGLA|VPLA|VTIN|VGLW|VGLG)\-/); } );
            limitLineQty( function(item){ return !!item.sku.match(/^(BEARLG|BEARSM)\-/); } );
            //limitLineQty( function(item){ return !!item.sku.match(/^BASK/); } );          
            //lockdownRegex( /^BASK/ );


            // Enforce Vday package present to get discounted/free addons
            let gatherLinesRegex = function( regex ){
                let lines = [];
                for (var i = 0; i < cartState.items.length; i++) {
                    if( !!cartState.items[i].sku.match(regex)  ){
                        lines.push( {index: i, item: cartState.items[i] });
                    }
                }
                return lines;
            };
            let removeLines = function( lines ){
                for( var i = 0 ; i< lines.length; i++){
                    $($('tr.cart__row')[ lines[i].index ]).find('p.cart__remove a').click();
                }
            };

            let packageTtm = gatherLinesRegex(/^[a-zA-Z]+\-12\-VDAYTM/);
            let packageAy = gatherLinesRegex(/^[a-zA-Z]+\-12\-VDAYAY/);
			let vdayFlash = gatherLinesRegex(/\-(VDAYFLASH|VDAYFLASHSAT)$/);
            if( packageTtm.length == 0 ){
                removeLines( gatherLinesRegex(/BASK.*\-1\-TTM/) );
            }
            if( packageAy.length == 0 && packageTtm.length == 0 && vdayFlash.length == 0 ){
                removeLines( gatherLinesRegex(/V[A-Z]+\-1\-VDAY/) );
            }

          
            
            // Lockdown Vday last Min products, only allow be purchased with baskets
             let lastMinRegex = /\-24\-VDAYLASTMIN(SAT)?$/;
             lockdownRegex(lastMinRegex);
             let lastMinProd = gatherLinesRegex(lastMinRegex);
             let nonBaskets = gatherLinesRegex(/^(?:(?!BASK).)*$/);
             if (lastMinProd.length > 0) {
                let toRemove = [];
                let nonBaskets = gatherLinesRegex(/^(?:(?!BASK).)*$/);
                for (var i = 0; i < nonBaskets.length; i++) {
                    let remove = true;
                    for (var j = 0; j < lastMinProd.length; j++) {
                        if (nonBaskets[i].index == lastMinProd[j].index) {
                            remove = false;
                        }
                    }
                    if (remove) {
                        toRemove.push(nonBaskets[i]);
                    }
                }
                removeLines(toRemove);
             }

            
            // Enforce various bundles being bought in their required quantity.  Functions gather applicable bundles, and second function determines if they can stay
            let verifyBundle = function( gather, complete ){

                let weddingBundles = 0;
                let cartRowEls = $('tr.cart__row');
                let weddingRows = [];
                let cartItems = [];

                for (var i = 0; i < cartState.items.length; i++) {

                    let item = cartState.items[i];
                    if ( gather( item )) {
                        weddingRows.push(cartRowEls[i]);
                        weddingBundles += item.quantity;
                        cartItems.push( item );
                        lockdownAddonRow(cartRowEls[i]);
                    }

                }

                if ( !complete( weddingRows, weddingBundles, cartItems ) ){
                    for (var i = 0; i < weddingRows.length; i++) {
                        $(weddingRows[i]).find('p.cart__remove a').click();
                    }
                }
            };

            // Enforce Wedding Bundles bought in quantities of 7
            verifyBundle( function( item ){
                return item.sku.match(/\-24\-BUNDLE$/) || item.sku.match(/\-24\-BUNDLESAT$/) || item.sku.match(/\-24\-PLUSBUNDLE/);
            }, function( rowEls, totalQty ){
                return totalQty == 7;
            } );

            // Enforce PROMO36  Bundles bought in quantities of 3
            verifyBundle( function( item ){
                return item.sku.match(/\-36PROMO$/) || item.sku.match(/\-36PROMOSAT$/);
            }, function( rowEls, totalQty ){
                return totalQty == 3;
            } );

            // Enforce Brads bundles bought in sets of 2
            let pairSkus = ["-EXCLUSIVE2", "-24PROMO", "-12-BOGO", "-CYMON","-HOLIDAY"];
            for( var i = 0; i < pairSkus.length; i++) {
                verifyBundle(function (item) {
                    return item.sku.indexOf(pairSkus[i]) > 0;
                }, function (rowEls, totalQty) {
                    return totalQty % 2 == 0;
                });
            }
          
            verifyBundle(function (item) {
                    return item.sku.match(/\-(VDAYFLASH|VDAYFLASHSAT)$/);
            }, function (rowEls, totalQty) { return totalQty % 2 == 0;});

            // Enforce X-4-UPSELLBOUQUET being sold in sets of 3 to make 12.
            verifyBundle( isQty4 ,function(rowEls, totalQty){
                return totalQty % 3 == 0;
            });

            // Enforce DA -12-CUSTOM sets don't include all -CUSTOMNEXT
            verifyBundle( function(item){
                return item.sku.indexOf("-12-CUSTOM") > 0;
            }, function( rowEls, totalQty, cartItems ){
                for( var i = 0; i < cartItems.length; i++){
                    if( cartItems[i].sku.substr(-7) == "-CUSTOM" || cartItems[i].sku.substr(-10) == "-CUSTOMSAT"){
                        return true;
                    }
                }
            });
          







            // Hide promo banners for non-discountable products
            let hasAnyDiscountableProducts = false;
            for (var i = 0; i < cartState.items.length; i++) {
                if( RF.isDiscountable( cartState.items[i].variant_id ) ){
                    hasAnyDiscountableProducts = true;
                }
            }
            if( !hasAnyDiscountableProducts ){
                $('.announcement-bar .partner-message').remove();
                $('body').addClass('no-discount');
            }
            // end hide promo banners for non-discountable products





            let submitButton = $('input.cart__submit');

            let initUpsellModal = function(){
                let submitForm = function(){
                    submitButton.click();
                };


                let orig = hasDAProduct ? "20" : "40";
                let discount = hasDAProduct ? "10.88" : "7.88";
                let collection = hasDAProduct ? "upsells" : "upsells";
                let stems = hasDAProduct ? 12 : 12;


                RF.cartUpsell = RF.initUpsellModal({
                    upsellSkuSuffix: "LASTCHANCE",
                    collectionHandle: collection,
                    headline: "Enjoy this Special Offer Just for You!<br/>Add " + stems + " More Roses for Only <s>$" + orig + "</s> <span></span><span>$" + discount + "</span>",
                    onDecline: function () {
                        submitForm();
                    },
                    onAccept: function (variant) {
                        let itemWithDate = null;
                        for (var j = 0; j < cartState.items.length; j++) {
                            if (typeof cartState.items[j].properties['Delivery Date'] != "undefined") {
                                itemWithDate = cartState.items[j];
                                break;
                            }
                        }

                        RF.addLinesToCart( [{
                            quantity: 1,
                            id: variant,
                            properties: itemWithDate == null ? {} : itemWithDate.properties
                        }]).then(submitForm);
                    }
                });

                return {
                    trigger: function(){
                        RF.cartUpsell.trigger([stems],[0]);
                    }
                };

            };


            // Init Upsell modal if needed
            let doUpsellModal = (typeof RF.cartUpsellInit == "undefined" && countStems >= 12 && countStems <= 24);
            let upsellModal = null;
doUpsellModal=false;
            if( doUpsellModal ){
                upsellModal = initUpsellModal();
            }

            let movingToCart = false;

            // Handle showing upsell modal (or not) and auto-applying coupons before checkout
            submitButton.off('click').click(function(){

                if( movingToCart ){
                    return true;
                }

                let applyAutoDiscountAndSubmit = function(){

                    let codes = [
                        {skuPattern: /\-(VDAYFLASH)/, code: "ACFLASHSALE" },
                        {skuPattern: /\-PROMO[0-9]{6,8}$/, code: "ACFLASHSALE" },
                        {skuPattern: /^BUND\-CUSTOM/, code: "ACFLASHSALE" },
                        {productId: "5862388334753", code: "ACFLASHSALE" },
                        {productId: "6107826651297", code: "ACFLASHSALE" },
                        {productId: "7322934444193", code: "ACFLASHSALE" },
                        {productId: "7323054866593", code: "ACFLASHSALE" },
                        {productId: "7331410084001", code: "ACFLASHSALE" },
                        {productId: "7331410215073", code: "ACFLASHSALE" },
                        {productId: "7355038498977", code: "ACFLASHSALE" },
                        {productId: "7589292572833", code: "ACFLASHSALE" }
                    ];

                    let codeToApply = null;

                    $('tr.cart__row').each(function(){
                        for( var i = 0; i < codes.length; i++){
                            if( codes[i].skuPattern && $(this).data('sku').match( codes[i].skuPattern ) ){
                                codeToApply = codes[i].code;
                            } else if( codes[i].productId && $(this).data('productid') == codes[i].productId ){
                                codeToApply = codes[i].code;
                            }
                        }
                    });

                    RF.cartCodesApplied = RF.cartCodesApplied || {};
                    console.log("Code to apply", codeToApply);

                    let submitForm = function(){
                        movingToCart = true;
                        submitButton.click();
                    };

                    if( codeToApply == null || RF.cartCodesApplied[ codeToApply ] ){
                        submitForm();
                    }  else {
                        RF.cartCodesApplied[ codeToApply ] = true;
                        var el = document.createElement('img');
                        el.src = "/discount/" + codeToApply ;
                        el.onload = function(script){
                            submitForm();
                        };
                        el.onerror = el.onload;
                        document.body.appendChild(el);
                    }
                };


                if( doUpsellModal ){
                    if( $(this).is('.modal-open') ){
                        applyAutoDiscountAndSubmit();
                    } else {
                        e.preventDefault();
                        $(this).addClass('modal-open');
                        upsellModal.trigger();
                    }
                } else {
                    applyAutoDiscountAndSubmit();
                }

                return false;

            });

            // allow other listeners to receive
            return true;

        }); // end on cart-redrawn event

        // cutoff date check
        $('#shopify-section-cart-template').on('cart-redrawn', function (e) {
return;
            let cartState = e.detail;
            let updates = [];
            let updatesIssued = 0;
            let updatesCompleted = 0;
            let handleUpdateComplete = function(){
                updatesCompleted++;
                if( updatesIssued == updatesCompleted ){
                    window.location.href = "/cart?newDate=" + encodeURIComponent(earliestFormatted);
                }
            };



            for( var i = 0; i < cartState.items.length; i++){
                let earliestDelivery = RF.getEarliestArrivalDay(3, RF.cleanVendor( cartState.items[i].vendor) );

                if( cartState.items[i].properties && cartState.items[i].properties["Delivery Date"] ){
                    // parse requested delivery date
                    let requestedDelivery = (cartState.items[i].properties["Delivery Date"]);
                    let requestedParts = requestedDelivery.match(/([a-zA-Z]+)\s([0-9]+)[a-z]{0,2}\s([0-9]+)$/);
                    requestedDelivery = moment( requestedParts[1] + " " + requestedParts[2] + " " + requestedParts[3]);

                    // avoid changing to Saturday, change to Monday instead (unless they selected Saturday)
                    if( earliestDelivery.day() == 6 && requestedDelivery.day() != 6 ){
                        earliestDelivery.add(2, 'days');
                    }
                    let earliestFormatted = earliestDelivery.format("dddd MMMM Do YYYY");

                    if( requestedDelivery.isBefore(earliestDelivery, 'day') ){

                        updatesIssued++;
                        fetch("/cart/change.js", {
                            method: "POST",
                            body: JSON.stringify({id: cartState.items[i].key, properties: {"Delivery Date": earliestFormatted}}),
                            headers: {"Content-Type": "application/json"}
                        }).then(function(data){ return data.json(); })
                            .then(function(){
                                handleUpdateComplete(earliestFormatted);
                            })
                            .catch(function(){
                                handleUpdateComplete(earliestFormatted);
                            });
                    }

                }
            }



        }); // end cutoff date check
      


        // Append cutoff date note if found
        let qs = parseQuery(window.location.search);
        if( qs.newDate ){
            $('h1.cart-header__title').after('<h2 class="alert alert-yellow cart-header__title"><b>Note:</b> The Shipping cutoff for your selected Delivery Date has passed.  We have updated your Delivery Date to the next available day, <b>' + qs.newDate + '</b>.</h2>');
        }

    }; // End RF.enforceUpsells()

    RF.isDiscountable = function( variantId ){
        return RF && RF.discountable && RF.discountable[ variantId];
    };

    RF.cartHasDiscountableProduct = function(cart){

    };

    RF.initMultiColor = function (config) {
        config = config || {};
        config.vendor = config.vendor || "A";
        const deliveryDateInput = document.getElementById("deliveryDate");
        let lineitems = [];
        $('.bundle-rows .bundle').remove();
        let addToCartButton = $('button[name=submit_btn]');
        let bouquetId = Math.random().toString(36).substr(2, 4);

        // Functions we return for external control
        let addLineItem = function (variantId, quantity) {

            let properties = {
                'Delivery Date': $(deliveryDateInput).val(),
                '_Bouquet ID': bouquetId,
                'From': $('#noteFrom').val(),
                'Note': $('#note').val(),
                '_recipientEmail': RF.getRecipientEmail(),
                '_agreements': Array.isArray(RF.agreements) ? RF.agreements.join(',') : 'none'
            };


            let reminder = RF.getReminderSelection();
            if (reminder != null) {
                properties.Reminder = reminder;
            }

            lineitems.push({id: variantId, quantity: quantity, properties: properties});
        };

        let submit = function () {
            if( config.onSubmit ){
                config.onSubmit( lineitems );
            } else {
                if (RF.isNoonDeliverySelected()) {
                    addLineItem(RF.config.noonDeliveryVariantId);
                }
                if( config.beforeSubmit ){
                  config.beforeSubmit();
                }
                $.post('/cart/add.js', {items: lineitems}, function () {
                    window.location.pathname = "/cart";
                }, 'json');
            }
        };
        // End External Functions


        let updateSelections = function () {
            let bundleQty = {};
            let sumStems = 0;
            let sumCost = 0;
            let satDelivery = moment($(deliveryDateInput).attr('data-date')).day() == 6;
            // start fresh and build up set of lineitems based on selected product(s)
            lineitems = [];

            $('.bundle-rows .bundle').each(function () {
                var color = $(this).data('color');
                if (typeof bundleQty[color] == "undefined") {
                    bundleQty[color] = 0;
                }
                bundleQty[color]++;
            });

            if( typeof config.bundleSortFunction == "function"){
                bundleQty = config.bundleSortFunction( bundleQty );
            }


            let addBundle = function (color, saturday, stemQty, liQty) {
                let variant = null;

                let collection = null;
                let skuSuffix = null;
                if( !!config.skuPicker ){
                    let ret = config.skuPicker( sumStems, stemQty, liQty, saturday);
                    collection = ret.collection;
                    skuSuffix = ret.skuSuffix;
                } else {
                    if (sumStems == 0) {
                        collection = config.firstCollection;
                        skuSuffix = (saturday ? config.skus.firstSat : config.skus.first);
                    } else {
                        collection = config.nextCollection;
                        skuSuffix = (saturday ? config.skus.nextSat : config.skus.next);
                    }
                }

                for (var i = 0; i < collection.length; i++) {
                    for (var j = 0; j < collection[i].variants.length; j++) {
                        if (collection[i].variants[j].sku == color + "-" + stemQty + skuSuffix) {
                            variant = collection[i].variants[j];
                        }
                    }
                }
                if (variant != null) {
                    sumStems += (liQty * stemQty);
                    sumCost += (liQty * variant.price);

                    if( typeof config.includeBundlesInLineItems == "undefined" || config.includeBundlesInLineItems ) {
                        addLineItem(variant.id, liQty);
                    }
                }
            };


            let firstAdd = true;
            let addedStemCount = 0;
            for (var color in bundleQty) {
                var colorQty = bundleQty[color];
                addedStemCount += (colorQty * config.bundleQty);
                if (firstAdd) {
                    addBundle(color, satDelivery, config.bundleQty, 1);
                    firstAdd = false;
                    colorQty--;
                }
                if (colorQty > 0) {
                    addBundle(color, satDelivery, config.bundleQty, colorQty);
                }
            }

            if( addons != null ){
                if( config.addonsSkuSlug ){
                    addons.setSkuSlug( config.addonsSkuSlug );
                } else {
                    addons.setSelectedQuantity(config.addonsSkuQty || addedStemCount );
                }

                let selectedAddons = addons.getSelected();
                for( var varId in selectedAddons ){
                    addLineItem( varId, selectedAddons[varId].qty );
                }
            }

            if( !!config.minStemCount && sumStems < config.minStemCount ){
                sumStems = config.minStemCount;
            }
            if( !!config.minCost && sumCost < config.minCost ){
                sumCost = config.minCost;
            }

            sumStems += (config.addonStemsCount || 0);
            sumCost += (config.addonStemsCost || 0);

            let label = $('.price-container label');
            if( typeof config.staticPrice == "undefined" ){
                if (RF.discountedAmount && sumCost > 0) {
                    label.html(sumStems + " Roses for <s>$" + (sumCost / 100).toFixed(2) + "</s> $" + RF.discountedAmount(sumCost / 100)).css('font-size', '21px');
                } else {
                    label.html(sumStems + " Roses for $" + (sumCost / 100).toFixed(2));
                }
            } else {
                if (RF.discountedAmount && config.staticPrice ) {
                    label.html(config.staticStems + " Roses for <s>$" + config.staticPrice + "</s> $" + RF.discountedAmount(config.staticPrice)).css('font-size', '21px');
                } else {
                    label.html(config.staticStems + " Roses for $" + config.staticPrice );
                }
            }
        };

	    let addons = RF.initAddons({onSelect: updateSelections, vendor: config.vendor});
        if( config.addonsSkuSlug ){
            addons.setSkuSlug( config.addonsSkuSlug );
        } else {
            addons.setSelectedQuantity(config.addonsSkuQty || config.bundleQty);
        }


        let handleChangedQuantity = function () {
            let bundles = $('.bundle-rows .bundle');

            if (!config.singleSelect && bundles.length >= config.maxbuy) {
                $('.products-container').addClass('products-container-disabled');
            } else {
                $('.products-container').removeClass('products-container-disabled');
            }

            if( config.noDuplicateProducts ){
                $('.product .product-disabled').remove();
                for( var i = 0; i < bundles.length; i++){
                    let bundleColor = $(bundles[i]).data("color");
                    $('.product[data-color="' + bundleColor + '"]').append('<div class="product-disabled"></div>');
                }
            }

            if (bundles.length < config.minbuy) {
                addToCartButton.attr('disabled', 'disabled');
            } else {
                addToCartButton.removeAttr('disabled');
            }

        };


        let prefixBundleRows = function(){
            // Re-prefix bundles
            if( config.lineitemPrefix ) {
                $('.bundle-rows .bundle').each(function (i, elem) {
                    $(this).find('.prefix').remove();
                    $(this).find('label').prepend('<span class="prefix">' +  config.lineitemPrefix(i) + '</span>');
                });
            }
        };


        // Remove markup that may indicate which color is active
        if( !(config  && config.singleSelect) ){
            $('.product.active').removeClass('active');
        }

        let stripTrailingParens = function(str){
            return str.replace(/\s+\([^)]+\)$/,"");
        };

        $('.product-image').off('click').click(function (e) {
            let newBundle = $('.bundle-template').clone().removeClass('bundle-template').css('display', 'flex');
            let origProd = $(this).parents('.product');
            newBundle.find('img').attr('src', $(this).data('thumb'));
            newBundle.find('label').html(config.bundleQty + " " + stripTrailingParens($(this).attr('alt')).replace("Stunner ","") );
            newBundle.data('color', origProd.data('color'));
            newBundle.data('colorlabel', origProd.data('colorlabel'));

            $('.product').removeClass('active');
            if( config.singleSelect ){
              	$('.bundle-rows .bundle').remove();
                newBundle.hide();
                $(this).parents('.product').addClass('active');
            }

            $('.bundle-rows').append(newBundle);

            if( config && config.onAddBundle ){
                config.onAddBundle();
            }

            prefixBundleRows();
            handleChangedQuantity();
            updateSelections();
        });

        if( !!config.hoverColorLabel ) {
            if ($('.product-color-label').length == 0) {
                $('.products-container').first().append('<div class="product-color-label">.</div>');
            }
            $('.product-image').off('hover').hover(function (e) {
                $('.product-color-label').css('visibility','visible').html( stripTrailingParens( $(this).parents('.product').data('title') ) );
            });
            $('.product-image').off('mouseout').mouseout(function (e) {
                $('.product-color-label').css('visibility','hidden');
            });
        }

        $('.bundle-rows').off('click').on('click', 'button.btn-remove', function () {
            $(this).parents('.bundle').remove();

            if( config && config.onRemoveBundle ){
                config.onRemoveBundle();
            }

            handleChangedQuantity();
            prefixBundleRows();
            updateSelections();
        });

        config.datePickerParams = config.datePickerParams || {};
        config.datePickerParams.deliveryDateInput = deliveryDateInput;
        config.datePickerParams.shipSpeed = 3;
        config.datePickerParams.datePickCallback = updateSelections;
        RF.initDeliveryDatePicker(config.datePickerParams);
        updateSelections();
        handleChangedQuantity();
        RF.initNoteField(updateSelections);
        RF.initPreviewImages();


        let weatherModal = RF.initWeatherModal();

        addToCartButton.off('click').click(function (e) {
            e.preventDefault();

            let submitLogic = function() {
                updateSelections(); // regenerate lineitems with agreements property set
                if (typeof config.externalSubmit == "undefined" || !config.externalSubmit) {
                    submit();
                }
            };

            if( RF.isSubmitPossible().possible ) {
                weatherModal.triggerIfNeeded(
                    $(deliveryDateInput).attr('data-date'),
                    submitLogic
                );
            }

            return false;
        });


        return {submit: submit, addLineItem: addLineItem, addons: addons};
    };


    RF.initPreviewImages = function() {
        $('.thumbs img').off('click').click(function (e) {
            $('.preview-image-container > img')
                .attr('src', $(this).data('full'))
                .attr('alt', $(this).attr('alt'));
        })
    };
    //RF.initDeliveryDatePicker = function (deliveryDateInput, shipSpeed, datePickCallback, config) {
    RF.initDeliveryDatePicker = function (config) {

        config = config || {};
        config.vendor = config.vendor || "A";

        let displayDayMessage = function (earliestDayNum, selectedDayNum) {
            $('.delivery-day-message').hide();
            $('.delivery-day-message-' + selectedDayNum).show();
            $('.sat-avail-message').hide();
            if ( config.vendor == "A" && earliestDayNum == 6 && selectedDayNum == 1) {
                //$('.sat-avail-message').show();
            }
        }

        if (config.deliveryDateInput != null) {
            earliestArrival = RF.getEarliestArrivalDay(config.shipSpeed, RF.cleanVendor(config.vendor) );

            // Allow for Saturday delivery, but never make it the default
            let defaultArrival = earliestArrival.clone();
          
          // overwrite default arrival with default date if passed
          if( config.defaultDate ){
                defaultArrival = new moment( config.defaultDate );
            }
          
            if( (config.vendor == "B" || config.vendor == "C" || config.vendor == "D") && defaultArrival.day() == 5 ){
              	defaultArrival.add(1,'day');
            }
            if ( defaultArrival.day() == 6 ) {
                let oldArrival = defaultArrival.clone();
                defaultArrival.add(2, 'day');
                defaultArrival = RF.closestDeliveryDate( defaultArrival, null, config.vendor );


                // Don't let default arrival date exceed max delivery date
                if( typeof RF.deliveryMaxDate == "object" ){
                    if( defaultArrival.isAfter( RF.deliveryMaxDate ) ){
                        defaultArrival = oldArrival;
                    }
                }
            }

            if( RF.deliveryMinDate ){
                if( defaultArrival.isBefore( RF.deliveryMinDate ) ) {
                    defaultArrival = moment(RF.deliveryMinDate);
                }
                if( earliestArrival.isBefore( RF.deliveryMinDate ) ){
                    earliestArrival = moment(RF.deliveryMinDate);
                }
            }


            if( typeof config.overwriteValue == "undefined" || config.overwriteValue ) {
                config.deliveryDateInput.value = defaultArrival.format("dddd MMMM Do YYYY");
                config.deliveryDateInput.setAttribute("data-date", defaultArrival.format("Y-MM-DD"));
            }


            let appendSaturdayCost = function(){
                return;
                if (typeof config == "undefined" || !!config.disableSaturday == false) {
                    let cal = $('#ui-datepicker-div');
                    cal.find('tbody tr').each(function () {
                        let saturday = $($(this).find('td').get(6));
                        if (saturday.html() != "&nbsp;") {
                            saturday.attr('title', '+$14');
                        }
                    });
                }
            };

          let initDateMonth = function(month, year ){

            $('#ui-datepicker-div .carrier-note').remove();
            $('#ui-datepicker-div').append('<div class="carrier-note"><span>Important!</span> In some instances, your carrier may deliver your roses 1 day early.  We will keep you apprised along the way. </div>');

            /*
            if( RF.blackoutDatepickerVweek && month == 2 && year == 2021){
              if( !window.location.href.match(/\/orders\//) ){
                $('#ui-datepicker-div').append('<div class="vday-overlay" style="position: absolute;left: 16px;top: 155px;right: 17px; background-color: rgba(255,255,255,0.3);height: 45px;line-height:  45px;text-align: center;font-weight: bold;"><a href="/collections/valentines" class="" style="color: #bb0000;">Shop Valentine\'s Week →</a></div>');
              }
            } else {
              $('.vday-overlay').remove();
            }
            */
          };

            $(config.deliveryDateInput).datepicker( "destroy" ).datepicker({
                beforeShow: function (input, inst, a, b, c) {
                    setTimeout(function () {
                        let offset = $(input).offset();
                        if( typeof offset.top != "undefined" ) {
                            inst.dpDiv.css({
                                top: offset.top + 35
                                //left: $(".datepicker").offset().left
                            });
                        }

                        appendSaturdayCost();
                    }, 0);
                  setTimeout(function(){
                    initDateMonth( inst.drawMonth+1, inst.drawYear);
                  }, 0);

                },
                onChangeMonthYear: function(year, month){
                    setTimeout(appendSaturdayCost, 0);
                  setTimeout(function(){
                    initDateMonth( month, year );
                  }, 0);
                },
                beforeShowDay: function (date) {

                    let dateStr = date.toISOString().split('T')[0];
                    let holidaySets = [RF.holidays, RF.vendorHolidays[ RF.cleanVendor(config.vendor) ]];
                  
                    for( var j = 0; j < holidaySets.length; j++){
                      if( Array.isArray( holidaySets[j] ) ){
                    	for (var i = 0; i < holidaySets[j].length; i++) {
                        	if (dateStr == holidaySets[j][i]) {
                            	return [false, ''];
                        	}
                    	}  
                      }
                    }
                    

                  
                    // block days with no inventory
                    if( RF.noInventoryDates && RF.noInventoryDates[ dateStr ] ){
                        return [false,''];
                    }

                    // Block Sunday
                  var dow = date.getDay();
				  if( dow == 0  ){
                    return [false,''];
                  }

                  switch( config.vendor ){
                    case "D":
                    case "E":
                        if( dow !=  3 && dow != 4 ){
                            return [false,''];
                        }
                        break;
                        if( dow !=  3 && dow != 4 ){
                            return [false,''];
                        }
                        break;

                  }

                  if( !!RF.disableFriday && dow == 5){
                    return [false, ''];
                  }
                  
                  // Enable/disable Saturday
                    let enableSaturday = false;
                  /*
                    if( !!RF.disableSaturday ) {
                        enableSaturday = false;
                    } else if (config && !!config.disableSaturday ){
                        enableSaturday = false;
                    } else if( config && (config.vendor == "B" || config.vendor == "C")){
                        enableSaturday = false;                              
                    }*/
                    return [(enableSaturday || dow != 6), ''];
                },
                // If Saturday is earliest date, default to the Monday instead
                defaultDate: config.defaultDate || defaultArrival.toDate(),
                maxDate: RF.deliveryMaxDate || null,
                minDate: config.defaultDate && config.defaultDate < earliestArrival.toDate() ? config.defaultDate : earliestArrival.toDate(),
                dateFormat: "DD MM d yy",
                onSelect: function (date, a, b, c, d) {
                    let dateStr = a.selectedYear + "-" + (a.selectedMonth < 9 ? "0" : "") + (a.selectedMonth + 1) + "-" + a.selectedDay;
                    config.deliveryDateInput.setAttribute("data-date", dateStr);
                    let selectedDelivery = moment(dateStr);
                    displayDayMessage(earliestArrival.day(), selectedDelivery.day());
                    config.datePickCallback( a );
                }
            });


            if( config.vendor == "A" ) {
                if ($('.noondelivery-container').length == 0) {
                    let cont = $('.datepicker-delivery h3.subtitle');
                    if (cont.length == 0) {
                        cont = $('.datepicker-delivery');
                    }
                    cont.after('<div class="field-container recommended-container"><label>Recommended for best Experience:</label></div><div class="field-container noondelivery-container"><label class="sized" style="display: flex; align-items: center; gap: 5px;"><input type="checkbox" name="noon_delivery" value="yes" checked="checked" style="flex-shrink: 0;"/><div class="order-graphic graphic-truck"></div><div style="margin: 0 5px; line-height: 22px;">Guaranteed Delivery By 2PM<div style="font-weight: 300; color: #888;">on the chosen delivery date</div></div><div>(+$' + RF.config.noonDeliveryPrice + ')</div></label></label></div>');                  
                }
                ;
                $('input[name=noon_delivery]').off('change').change(config.datePickCallback);
                $('.noondelivery-container').show();
                $('.noondelivery-container input[name=noon_delivery]').prop('checked', true);
            }
            displayDayMessage(earliestArrival.day(), defaultArrival.day());
        }
    };


    RF.initNotesModal = function (config) {

        let seenCookieName = "order_popup_" + config.order;

        let initialValues = {};

        let notes = $('#notesModal');

        let isButtonDisabled = function(){ return notes.find('.btn-add-note').is('.disabled'); }
        let disableButton = function(){ notes.find('.btn-add-note').addClass('disabled'); }
		let enableButton = function(){ notes.find('.btn-add-note').removeClass('disabled'); };
      
        let doFetch = function (data) {
            return fetch("https://orders.rosefarmers.com/api/manage-notes", {
                method: "POST",
                body: JSON.stringify(data),
                headers: {"Content-Type": "application/json"}
            });
        };
      
        let postNotes = function (notesTxt, noteFrom, first, last, address1, address2, city, state, zip, deliveryDate) {
            disableButton();
            doFetch({
                action: "addNotes",
                shopify_order_id: config.shopifyOrderId,
                order: config.order,
                email: config.email,
                note: notesTxt,
                note_from: noteFrom,
                first_name: first,
                last_name: last,
                address1: address1,
                address2: address2,
                city: city,
                state: state,
                zip: zip,
                country: "US",
                delivery_date: deliveryDate,
                initial_values: initialValues
            })
                .then(function (data) {
                    return data.json();
                })
                .then(function (data) {
                    if (data.success) {
                        notes.hide();
                        setCookie(seenCookieName, "true", 365);
                        $('#savedModal').css('display', 'flex');
                    } else {
                        console.log(data);
                        alert(data.error || "An error occurred.  Please try again.");
                    }
					enableButton();
                })
                .catch(function (error) {
                    console.log(error);
                    alert("An error occurred.  Please try again.");
                    enableButton();                            		
                })
            ;
        };

        notes.find('select[name=state] option[value=' + config.shipState + ']').prop('selected', true);

        let formElementChanged = function(){
            notes.find('.btn-add-note').html('Save Changes');
        };
        notes.find('select,input,textarea').on('keyup change', formElementChanged);

        notes.find('.btn-add-note').click(function () {
          if( isButtonDisabled()  ){ return; }
            postNotes(
                $(notes).find('textarea[name=note_text]').val(),
                $(notes).find('input[name=note_from]').val(),
                $(notes).find('input[name=first_name]').val(),
                $(notes).find('input[name=last_name]').val(),
                $(notes).find('input[name=address1]').val(),
                $(notes).find('input[name=address2]').val(),
                $(notes).find('input[name=city]').val(),
                $(notes).find('select[name=state]').val(),
                $(notes).find('input[name=zip]').val(),
                $(notes).find('input[name=delivery_date]').val()
            );
        });

        notes.find('.close,.btn-close').click(function () {
            setCookie(seenCookieName, "true", 365);
            $(this).parents('.rf-modal, .mr-modal').hide();
        });

        $('#savedModal .btn-close').click(function (e) {
            e.preventDefault();
            setCookie(seenCookieName, "true", 365);
            window.location.reload();
            return false;
        });


        if ( getCookie(seenCookieName) == "") {
            doFetch({action: "getNotesStatus", order: config.order, email: config.email})
                .then(function (data) {
                    return data.json();
                })
                .then(function (data) {
                    if ( data.success && data.acceptsNotes) {
                        if (data.hasExistingData) {
                            $(notes).find('[name=first_name]').val(data.first_name);
                            $(notes).find('[name=last_name]').val(data.last_name);
                            $(notes).find('[name=address1]').val(data.address1);
                            $(notes).find('[name=address2]').val(data.address2);
                            $(notes).find('[name=city]').val(data.city);
                            $(notes).find('[name=state]').val(data.state);
                            $(notes).find('[name=zip]').val(data.zip);
                            $(notes).find('[name=note_text]').val(data.note);
                            $(notes).find('[name=note_from]').val(data.note_from);
                            $(notes).find('[name=delivery_date]').val(data.delivery_date);
                        }

                        initialValues = {
                            first_name: $(notes).find('[name=first_name]').val(),
                            last_name: $(notes).find('[name=last_name]').val(),
                            address1: $(notes).find('[name=address1]').val(),
                            address2: $(notes).find('[name=address2]').val(),
                            city: $(notes).find('[name=city]').val(),
                            state: $(notes).find('[name=state]').val(),
                            zip: $(notes).find('[name=zip]').val(),
                            note: $(notes).find('[name=note_text]').val(),
                            note_from: $(notes).find('[name=note_from]').val(),
                            delivery_date: $(notes).find('[name=delivery_date]').val()
                        }



                        let requestedParts = initialValues.delivery_date.match(/([a-zA-Z]+)\s([0-9]+)[a-z]{0,2}\s([0-9]+)$/);
                        let requestedDelivery = moment( requestedParts[1] + " " + requestedParts[2] + " " + requestedParts[3]);

                        RF.initDeliveryDatePicker(
                            {
                                deliveryDateInput: $(notes).find('[name=delivery_date]')[0],
                                shipSpeed: 3,
                                datePickCallback: formElementChanged,
                                disableSaturday: true,
                                defaultDate: requestedDelivery.toDate(),
                                overwriteValue: false
                            });
                      
						enableButton();
                        notes.css('display', 'flex');
                    }
                });
        }

    };
    // end init notes modal

    // init prepaid Sub
    RF.initPrepaidSubscription = function (config) {

        let multicolor = null;

        let onSubmit = function ( lines ) {

            let common = RF.getCommonProperties(multicolor.addons);

            lines.push(  {id: $('.quantity.quantity-active').data('varid'), quantity: 1, properties: common.properties} );

            RF.addLinesToCart( lines ).then( function(){ window.location.href = "/cart"; } );
        };

        let initMultiColor = function () {

            multicolor = RF.initMultiColor({
                minbuy: 0, //config.months,
                maxbuy: 0, //config.months,
                addonsSkuSlug: "SUB" + config.months + "QTY" + $('.quantity-active').data('qty'),
                bundleQty: "", // added to lineitems
                firstCollection: config.products,
                nextCollection: config.products,
                skus: {first: '', firstSat: '', next: '', nextSat: ''},
                onSubmit: onSubmit,
                datePickerParams: {disableSaturday: true},
                lineitemPrefix: function (i, data) {
                    return "Month " + (i + 1) + ":";
                }
            });
        };

        $('.quantity').click(function (e) {
            $('.quantity.quantity-active').removeClass('quantity-active');
            $(this).addClass('quantity-active');
            initMultiColor();
        });

        initMultiColor();

    };
    // end init 3 month sub

    //init All In Pricing / Multi Color / Multi Select
    RF.initAllInMultiQty = function (products, suffix, saturdaySuffix) {

        $('.quantity').click(function (e) {
            e.preventDefault();

            $('.quantity.quantity-active').removeClass('quantity-active');
            $(this).addClass('quantity-active');
            $('.product.active').removeClass('active');

            let multiColor = null;

            if( $(this).is('.quantity-12-custom') ){
                $('h3.product-prompt').html('Click to Choose Colors:');

                multiColor = RF.initMultiColor({
                    minbuy: 3,
                    maxbuy: 3,
                    bundleQty: 4,
                    firstCollection: products,
                    nextCollection: products,
                    skus: {first: '-' + suffix, firstSat: '-' + saturdaySuffix, next: '-' + suffix, nextSat: '-' + saturdaySuffix},
                    staticPrice: "38.88",
                    staticStems: 12
                });

            } else {
                $('h3.product-prompt').html('Select One Color:');

                multiColor = RF.initMultiColor({
                    minbuy: 1,
                    maxbuy: 1,
                    bundleQty: $(this).is('.quantity-12') ? 12 : 24,
                    firstCollection: products,
                    nextCollection: products,
                    skus: {first: '-' + suffix, firstSat: '-' + saturdaySuffix, next: '-' + suffix, nextSat: '-' + saturdaySuffix},
                    singleSelect: true
                });
            }

            $('.price-container').hide();

            // setup upsell modal
            RF.initUpsellModal({
                onAccept: function(variantId ){ multiColor.addLineItem( variantId, 1); multiColor.submit(); },
                onDecline: function(){ multiColor.submit(); },
                collectionHandle: "upsells-no-discount"
            });

            return false;

        });

        $('.quantity-12-custom').click();
    };
    // end All In pricing / Muli Color / Multi Select


    // helper to append common properties to form
    RF.isNoonDeliverySelected = function () {
        let noonDelivery = $('.noondelivery-container input[name=noon_delivery]:checked');
        return noonDelivery.length > 0;
    };
    RF.getReminderSelection = function () {
        let reminder = $('.reminder-container input[name=annualreminder]:checked');
        if (reminder.length > 0) {
            return $('.reminder-container select').val() || "Other";
        }
        return null;
    };

	RF.getRecipientEmail = function(){
		return $('.delivery-alert-container').not('.invalid-email').find('input[name=recipientEmail]').val();
	};
	
	RF.getCommonProperties = function( addonsModule ){
        let properties = {
            "Delivery Date": $('#deliveryDate').val(),
            "_Bouquet ID":  Math.random().toString(36).substr(2, 4),
            "_recipientEmail": RF.getRecipientEmail(),
            "_domain": location.hostname
        };

        if( Array.isArray(RF.agreements) ){
            properties["_agreements"] = RF.agreements.join(',');
        }

        let reminder = RF.getReminderSelection();
        if (reminder != null) {
            properties['Reminder'] = reminder;
        }


        let extraItems = [];


        let noteFrom = $('#noteFrom').val();
        let note = $('#note').val();
        let noteProductId = $('.note-prompt-container').data('noteproductid');
        if( noteProductId ){
            if( $('#noteToggle').prop('checked') ) {
                extraItems.push({id: noteProductId, quantity: 1, properties: {"From": noteFrom, "Note": note}});
            }
        } else {
            properties.From = noteFrom;
            properties.Note = note;
        }
      

        if (RF.isNoonDeliverySelected()) {
            extraItems.push( {id: RF.config.noonDeliveryVariantId, quantity: 1} );
        }

        if( typeof addonsModule != "undefined" && addonsModule != null ) {
            for ( var variantId in addonsModule.getSelected() ){
                extraItems.push( {id: variantId, quantity: 1} );
            }
        }

        return {properties: properties, lines: extraItems};
    };

    RF.initCustomBouquet = function(config){

      
        let upsellModal = null;

        $('.quantity-picker .btn').click(function(e){
            e.preventDefault();

            $('.quantity-picker .btn.btn-active').removeClass('btn-active');
            $(this).addClass('btn-active');

            if( $(this).is('.btn-1dozen') ){
                $('h3.product-prompt').html('Mix & Match 12 Roses - Choose 3:');

                $('.quantity-active').remove();
                $('body').append('<div class="quantity-active quantity-12"/>');

                let multiColor = RF.initMultiColor({
                    minbuy: 3,
                    maxbuy: 3,
                    bundleQty: 4,
                    firstCollection: RF.upsellProducts,
                    nextCollection: RF.upsellProducts,
                    skus: config.suffixes["12"], //{first: '-UPSELLBOUQUET', firstSat: '-UPSELLBOUQUETSAT', next: '-UPSELLBOUQUET', nextSat: '-UPSELLBOUQUETSAT'},
                    staticPrice: config.twelvePrice,
                    staticStems: 12
                });

                if( config && !!config.upsellPopup ) {
                    // setup upsell modal
                    upsellModal = RF.initUpsellModal({
                        collectionHandle: config.upsellsCollection || "upsells",
                        originalPricer: config.modalPricer || null,
                        onAccept: function (variantId) {
                            multiColor.addLineItem(variantId, 1);
                            multiColor.submit();
                        },
                        onDecline: function () {
                            multiColor.submit();
                        }
                    });
                }

            } else {
                $('h3.product-prompt').html('Mix Up To 4 Dozen - Choose Colors:');

                if( upsellModal != null && upsellModal.deinit ){
                    upsellModal.deinit();
                }

                RF.initMultiColor({
                    minbuy: 1,
                    maxbuy: 4,
                    bundleQty: 12,
                    firstCollection: RF.standardProducts,
                    nextCollection: RF.upsellProducts,
                    skus: config.suffixes["24"], //{first: '', firstSat: '-SAT', next: '-UPSELLBOUQUET', nextSat: '-UPSELLBOUQUET'}
                });
            }
            return false;

        });

        $('.btn-1dozen').click();

    };

    RF.initVday = function (config) {


        let headlineFunc = function(doz){
            return doz ==  1 ? "Click To Select Color" : 'Click ' + doz + ' Colors To Add ' + doz + ' Dozen:';
        };


        let bundleQty = 12;


        $('.quantity').click(function (e) {
            e.preventDefault();

            $('.quantity.quantity-active').removeClass('quantity-active');
            $(this).addClass('quantity-active');
            $('.product.active').removeClass('active');

            let multiColor = null;


            let addPackage = function(){
                if (config.packageVariantId) {
                    multiColor.addLineItem(config.packageVariantId, 1);
                }
            };

            let dozens = $(this).data("dozens");
            let mindozens = $(this).data("dozensmin") || dozens;

            $('h3.product-prompt').html(headlineFunc( dozens ) );


            multiColor = RF.initMultiColor({
                minbuy: mindozens,
                maxbuy: dozens,
                bundleQty: bundleQty,
                firstCollection: config.products,
                nextCollection: config.productsSecond || config.products,
                skus: config.skus,
                bundleSortFunction: function( obj ){
                    let bundles = [];
                    for( var key in obj ){
                        bundles.push( {key: key, val: obj[key]});
                    }

                    // Sort bundles by reverse order of collection (cost high to low)
                    let newBundles = {};
                    for( var i = config.products.length - 1; i >= 0; i-- ){
                        let color = config.products[i].variants[0].sku.split("-")[0];
                        for( var j = 0; j < bundles.length; j++ ){
                            if( bundles[j].key == color ){
                                newBundles[ color ] = bundles[j].val;
                            }
                        }
                    }

                    return newBundles;
                },
                hoverColorLabel: true,
                skuPicker: config.skuPicker,
                addonStemsCost: config.packageBaseCost,
                minStemCount: (dozens * 12),
                minCost: $(this).data('minprice'),
                beforeSubmit: addPackage
            });

            if( dozens < 3 ) {
                // setup upsell modal
                RF.initUpsellModal({
                    onAccept: function (variantId) {
                        multiColor.addLineItem(variantId, 1);
                        multiColor.submit();
                    },
                    onDecline: function () {
                        multiColor.submit();
                    },
                    collectionHandle: "valentines-upsells",
                    upsellQtys: [12],
                    upsellSkuSuffix: "VDAYUPSELL",
                    originalPricer: function (qty) {
                        return 32;
                    }
                });
            } else {

            }
          
            return false;
        });

        $('.quantity[data-dozens=2]').click();
    };
    // end VDay

    RF.initAddonDescriptions = function( containers ){
        let hideDescriptions = function(){ $('.sub-item-image-container').removeClass('show-description'); };

        containers.find('.sub-item-image-container > *')
            .on('mouseover click',function() {
                hideDescriptions();
                $(this).parents('.sub-item-image-container').addClass('show-description');
            })
            .on('mouseout',function(){
                hideDescriptions();
            });
    };
  
  	RF.initSaleCommon = function(){
      RF.blackoutVdayDates();
  	};
  
  	RF.blackoutVdayDates = function(){
      RF.holidays.push("2025-01-31");
      RF.holidays.push("2025-02-03");
      RF.holidays.push("2025-02-04");
      RF.holidays.push("2025-02-05");
      RF.holidays.push("2025-02-06");
      RF.holidays.push("2025-02-07");
      RF.holidays.push("2025-02-10");
      RF.holidays.push("2025-02-11");
      RF.holidays.push("2025-02-12");
      RF.holidays.push("2025-02-13");
      RF.holidays.push("2025-02-14");
      RF.holidays.push("2025-02-15");
  	};
  
  RF.enableShippingDate = function( goodDate ){
    RF.holidays = RF.holidays.filter( function(o){ return goodDate != o; } );
  };

  RF.addLinesToCart = function(lines){
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({ items: lines })
    });
  };

  RF.blockAddons = function(ids) {
    RF.blockedAddons = RF.blockedAddons || {};
    for( var i= 0; i < ids.length; i++ ){
      RF.blockedAddons[ ids[i] ] = true;
    }    
  };

    


})(jQuery);
